// add posts via ajax
jQuery(function($){ // use jQuery code inside this to avoid "$ is not defined" error


	$('#nextweek').click(function(){
    var eventType = $('#filter-select').val();
    var week = $('.week').attr('id');
		var year = $('.month-year').attr('id');
     week++;
     $('#nextweek').show();
     if (week > 52) {
			 	year++;
        week = 1;
     }
		var button = $(this),
		    data = {
			'action': 'loadmore',
			'query': loadmore_params.posts, // that's how we get params from wp_localize_script() function
      'nextweek' : week,
			'year' : year,
      'type' : eventType
		};

		$.ajax({ // you can also use $.post here
			url : loadmore_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$("#week-control").text('lataa' ); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {
          $("#events").empty();
        	 $("#week-control").text( 'Viikko '+ week );

          $("#events").append(data); // insert new posts

					loadmore_params.current_page++;

					if ( loadmore_params.current_page == loadmore_params.max_page )
						button.remove(); // if last page, remove the button



				} else {
					button.remove(); // if no data, remove the button as well
				}


			}
		});
	});

  $('#previousweek').click(function(){

    var eventType = $('#filter-select').val();
    var week = $('.week').attr('id');
		var year = $('.month-year').attr('id');
     week--;
     if (week < 1) {
        week = 52;
				year--;
        // $('#nextweek').show();
     }


		var button = $(this),
		    data = {
			'action': 'loadmore',
			'query': loadmore_params.posts, // that's how we get params from wp_localize_script() function
      'nextweek' : week,
			'year' : year,
      'type' : eventType
		};

		$.ajax({ // you can also use $.post here
			url : loadmore_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$("#week").text('lataa' ); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {
             $("#events").empty();
					 $("#week-control").text( 'Viikko '+ week );
          $("#events").append(data); // insert new posts
					loadmore_params.current_page++;

					if ( loadmore_params.current_page == loadmore_params.max_page )
						button.remove(); // if last page, remove the button


				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});
	});

  $('#filter-select').on('change', function (e) {
      var optionSelected = $("option:selected", this);
      var valueSelected = this.value;
			var year = $('.month-year').attr('id');
      var week = $('.week').attr('id');

		var button = $(this),
		    data = {
			'action': 'loadmore',
			'query': loadmore_params.posts, // that's how we get params from wp_localize_script() function
      'nextweek' : week,
			'year' : year,
      'type' : valueSelected
		};

		$.ajax({ // you can also use $.post here
			url : loadmore_params.ajaxurl, // AJAX handler
			data : data,
			type : 'POST',
			beforeSend : function ( xhr ) {
				$("#week").text('lataa' ); // change the button text, you can also add a preloader image
			},
			success : function( data ){
				if( data ) {
           $("#events").empty();
					 $("#week-control").text( 'Viikko '+ week );
          $("#events").append(data); // insert new posts
					loadmore_params.current_page++;

					if ( loadmore_params.current_page == loadmore_params.max_page )
						button.remove(); // if last page, remove the button


				} else {
					button.remove(); // if no data, remove the button as well
				}
			}
		});

  });


});



// WEBPACK FOOTER //
// ./assets/js/myloadmore.js